(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  function normalizeNeyaMenuLabel(value) {
    return (value || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLocaleLowerCase(document.documentElement.lang || 'fr');
  }

  function getNeyaMenuItemLabel(element) {
    const clone = element.cloneNode(true);

    clone
      .querySelectorAll('svg, .icon, .neya-menu-badge')
      .forEach((node) => node.remove());

    return normalizeNeyaMenuLabel(clone.textContent);
  }

  function initializeNeyaMenuBadges(scope = document) {
    const configs = scope.matches?.('[data-neya-menu-badge-config]')
      ? [scope]
      : Array.from(
          scope.querySelectorAll('[data-neya-menu-badge-config]')
        );

    configs.forEach((config) => {
      const sectionRoot =
        config.closest('.shopify-section') || document;

      sectionRoot
        .querySelectorAll('.neya-menu-badge')
        .forEach((badge) => {
          if (!badge.closest('template')) {
            badge.remove();
          }
        });

      sectionRoot
        .querySelectorAll('.neya-menu-link--badged')
        .forEach((item) => {
          item.classList.remove('neya-menu-link--badged');
        });

      const desktopItems = Array.from(
        sectionRoot.querySelectorAll(
          '.header__inline-menu > .list-menu > li > a.header__menu-item, ' +
          '.header__inline-menu > .list-menu > li > header-menu > details > summary.header__menu-item'
        )
      );

      const mobileItems = Array.from(
        sectionRoot.querySelectorAll(
          '.menu-drawer__navigation > .menu-drawer__menu > li > a.menu-drawer__menu-item, ' +
          '.menu-drawer__navigation > .menu-drawer__menu > li > details > summary.menu-drawer__menu-item'
        )
      );

      config
        .querySelectorAll('[data-neya-menu-badge-template]')
        .forEach((template) => {
          const expectedLabel = normalizeNeyaMenuLabel(
            template.dataset.menuItemLabel
          );

          const visibility =
            template.dataset.visibility || 'both';

          const targets = [];

          if (
            visibility === 'both' ||
            visibility === 'desktop'
          ) {
            targets.push(...desktopItems);
          }

          if (
            visibility === 'both' ||
            visibility === 'mobile'
          ) {
            targets.push(...mobileItems);
          }

          targets.forEach((target) => {
            if (
              getNeyaMenuItemLabel(target) !== expectedLabel
            ) {
              return;
            }

            const badge =
              template.content.firstElementChild?.cloneNode(true);

            if (!badge) return;

            target.classList.add('neya-menu-link--badged');
            target.appendChild(badge);
          });
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => initializeNeyaMenuBadges()
    );
  } else {
    initializeNeyaMenuBadges();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initializeNeyaMenuBadges(event.target);
    }
  );

  document.addEventListener(
    'shopify:block:select',
    (event) => {
      const section =
        event.target.closest?.('.shopify-section');

      if (section) {
        initializeNeyaMenuBadges(section);
      }
    }
  );

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.headerBounds = {};

      this.setHeaderHeight();

      window
        .matchMedia('(max-width: 990px)')
        .addEventListener(
          'change',
          this.setHeaderHeight.bind(this)
        );

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add(
          'shopify-section-header-sticky'
        );
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch =
        this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp =
        () => this.preventReveal = true;

      this.addEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );

      window.addEventListener(
        'scroll',
        this.onScrollHandler,
        false
      );

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty(
        '--header-height',
        `${this.header.offsetHeight}px`
      );
    }

    disconnectedCallback() {
      this.removeEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );

      window.removeEventListener(
        'scroll',
        this.onScrollHandler
      );
    }

    createObserver() {
      const observer = new IntersectionObserver(
        (entries, currentObserver) => {
          this.headerBounds =
            entries[0].intersectionRect;

          currentObserver.disconnect();
        }
      );

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop;

      if (
        this.predictiveSearch &&
        this.predictiveSearch.isOpen
      ) {
        return;
      }

      if (
        scrollTop > this.currentScrollTop &&
        scrollTop > this.headerBounds.bottom
      ) {
        this.header.classList.add(
          'scrolled-past-header'
        );

        if (this.preventHide) return;

        requestAnimationFrame(
          this.hide.bind(this)
        );
      } else if (
        scrollTop < this.currentScrollTop &&
        scrollTop > this.headerBounds.bottom
      ) {
        this.header.classList.add(
          'scrolled-past-header'
        );

        if (!this.preventReveal) {
          requestAnimationFrame(
            this.reveal.bind(this)
          );
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(
            this.hide.bind(this)
          );
        }
      } else if (
        scrollTop <= this.headerBounds.top
      ) {
        this.header.classList.remove(
          'scrolled-past-header'
        );

        requestAnimationFrame(
          this.reset.bind(this)
        );
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky'
      );

      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add(
        'shopify-section-header-sticky',
        'animate'
      );

      this.header.classList.remove(
        'shopify-section-header-hidden'
      );
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );
    }

    closeMenuDisclosure() {
      this.disclosures =
        this.disclosures ||
        this.header.querySelectorAll('header-menu');

      this.disclosures.forEach(
        (disclosure) => disclosure.close()
      );
    }

    closeSearchModal() {
      this.searchModal =
        this.searchModal ||
        this.header.querySelector('details-modal');

      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define(
      'sticky-header',
      StickyHeader
    );
  }

  } catch(e) { console.error(e); }
})();
})();
